module.exports = __webpack_public_path__ + "files/9133601c368470a6ff01b843e80cebbc.png";